import {BaseMuWidget} from "./BaseMuWidget";
import {InvoiceApprovalCL} from "./generated/InvoiceApprovalCL";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {UiTomSelect} from "./components/UiTomSelect";
import {TomOption} from "tom-select/dist/types/types";
import {UiDms} from "./dms/UiDms";
// @ts-ignore
import {Sortable} from "sortablejs";
import {CachedPromise} from "./CachedPromise";
import {TreeSelector} from "./TreeSelector";
import {ErrorMarker} from "./ErrorMarker";
import {ErrorListMessages} from "./Types";
import {flashError, flashInfo, formatDate, Utils} from "./Utils";
import {UiFlashMessageContainer} from "mu-widget/lib/UiFlashMessage";
import {BaseWidget} from "./BaseWidget";
import {UiBuSubjectEditor} from "./dms/UiBuSubjectEditor";
import {DmsCL} from "./generated/DmsCL";
import {InvoiceApproval} from "./InvoiceApproval";
import {UiTicketRels} from "./UiTicketRels";
import {UiAttaches} from "./UiAttaches";

export class InvoiceCreator extends BaseWidget {
	public buSubjectId: number = 5;
	// @ts-ignore
	public ticketId: number;
	// @ts-ignore
	public invoiceId: number;
	public projectId: number|null = null;


	public cl: InvoiceApprovalCL = new InvoiceApprovalCL();

	public orgDivisionPromise = new CachedPromise(() => this.cl.withMessage('Načítám organizační jednotky').getOrgDivisions(this.buSubjectId, true));
	public orgProjectPromise = new CachedPromise(() => this.cl.withMessage('Načítám projekty').getOrgProjects(this.buSubjectId, true));
	public orgProductPromise = new CachedPromise(() => this.cl.withMessage('Načítám produkty').getOrgProducts(this.buSubjectId, true));
	private lastIco: string = "";

	beforeIndex() {
		this.muAppendContent(`
			<div class="alert alert-success" mu-id="pIsCreated">Doklad byl vytvořen. Pro vytvoření dalšího dokladu založte nový požadavek.</div>
			<div mu-id="pInvoice">
				<div mu-id="pInvoiceHeader" class="row">
					<div class="col-md-6">
						<h3>Informace o faktuře</h3>
						<table class="table">
							<tbody>
								<tr>
									<td>Číslo objednávky</td>
									<td class="text-right"><input class="form-control" type="text" mu-bind="orderNumber" /></td>
								</tr>
								<tr>
									<td>Datum vystavení</td>
									<td class="text-right"><input class="form-control" type="date" mu-bind="issueDate" /></td>
								</tr>
								<tr>
									<td>Splatnost</td>
									<td class="text-right"><input class="form-control" type="date" mu-bind="maturityDate" /></td>
								</tr>
								<tr>
									<td>DUZP</td>
									<td class="text-right"><input class="form-control" type="date" mu-bind="vatDate" /></td>
								</tr>
								<tr>
									<td>Variabilní symbol</td>
									<td class="text-right"><input class="form-control" type="text" mu-bind="variableSymbol" /></td>
								</tr>
								<!-- <tr>
								<td>Kontantní symbol</td>
								<td class="text-right"><input class="form-control" type="text" mu-bind="constantSymbol" /></td>
							</tr>
							<tr>
								<td>Částka bez DPH</td>
								<td class="text-right" mu-bind="price|priceV"></td>
							</tr> -->
								<tr>
									<td>Interní číslo faktury</td>
									<td class="text-right"><input class="form-control" type="text" mu-bind="invoiceNumber"></td>
								</tr>
								<tr>
									<td>Měna</td>
									<td class="text-right"><select class="form-control" mu-bind="currencyId;currencies:@options"></select></td>
								</tr>
							</tbody>
						</table>
					</div>
			
					<div class="col-md-6">
						<h3>
							Dodavatel
						</h3>
						<div mu-widget="UiTomSelect" mu-id="vendorSelector" mu-bind="vendorId">
							<div mu-template="item" mu-widget=".">
								<strong mu-bind="name"></strong>
								<em mu-bind="identificationNumber"></em>
								<small mu-bind="city"></small>
							</div>
						</div>
						<table class="table" mu-widget="." mu-bind="vendor">
							<tbody>
								<tr>
									<td>Název</td>
									<td class="text-right" mu-bind="name"></td>
								</tr>
								<tr>
									<td>IČ</td>
									<td class="text-right" mu-bind="identificationNumber"></td>
								</tr>
								<tr>
									<td>Ulice</td>
									<td class="text-right" mu-bind="street"></td>
								</tr>
								<tr>
									<td>Město</td>
									<td class="text-right"><span mu-bind="zip_code"></span> <span mu-bind="city"></span></td>
								</tr>
							</tbody>
						</table>
						<div class="buttons">
							<span class="icon-before-add btn-icon btn-icon-size-4" mu-id="dAddVendor">Přidat dodavatele</span>
						</div>
					</div>
				</div>
			
				<div class="clearfix"></div>
				<div mu-id="attaches" mu-widget="UiAttaches"></div>
				<!-- <div mu-id="pAttaches" class="invoice-approval--attaches row">
					<div class="col-md-3" mu-id="pAttachesList">
						<h3>Přílohy</h3>
						<ul mu-id="attachList" mu-bind="attachList:@foreach">
							<li mu-widget="InvoiceCreatorAttachesListItem" mu-template="attachListItem"
								mu-bind="id:.id;contentType:.contentType" class="invoice-approval--attach">
								<span class="invoice-approval--attache-item a" mu-id="name" mu-bind="fileName"></span>
							</li>
						</ul>
						<div class="text-center">
							<label class="checkbox" title="Zobrazit přílohy které pravděpodobně nebosahují fakturu"><input mu-id="showAttachJunk" type="checkbox" />zobrazit vše</label>
						</div>
					</div>
					<div class="col-md-9" mu-id="pPreview">
						<div mu-id="preview"></div>
						<div class="buttons"><span class="a" mu-id="bClosePreview">Zavřít náhled</span></div>
					</div>
				</div> -->
			
				<h3>Položky</h3>
				<table class="invoice-creator-items table" mu-id="pItems">
					<thead>
						<tr>
							<th class="text-center"><input type="checkbox" mu-id="checkAll">
							</th>
							<th class="text-center">Bez projektu</th>
							<th class="text-center">Projekt</th>
							<th class="text-center">Středisko - povinné</th>
							<th class="text-center">Název</th>
							<th class="text-center">Počet</th>
							<th class="text-center">Cena za jednotku bez DPH</th>
						</tr>
					</thead>
					<tbody mu-id="items" mu-bind="items::@foreach">
						<tr mu-widget="InvoiceCreatorItem" mu-template="item">
							<td><input type="checkbox" mu-id="forSet" /></td>
							<td class="text-center"><input type="checkbox" mu-bind="withoutProject" mu-id="withoutProject" /></td>
							<td>
								<div mu-widget="UiTomSelect" mu-bind="projectId" mu-id="projectId"></div>
							</td>
							<!-- <td><div mu-widget="TreeSelector" mu-id="organizationUnitId" mu-bind="organizationUnitId" mu-params='{"inModal":true}'></div></div></td> -->
							<td>
								<div mu-widget="UiTomSelect" mu-id="organizationUnitId" mu-bind="organizationUnitId"></div>
							</td>
							<td><input type="text" class="form-control" mu-bind="name" /></td>
							<td><input type="number" step="0.01" class="form-control" mu-bind="quantity" /></td>
							<td><input type="number" step="0.01" class="form-control" mu-bind="unitPrice"></td>
							<td>
								<a class="btn-icon icon-before-remove" mu-id="bRemove"></a>
								<a class="btn-icon icon-before-sortable-handle handle"></a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			
			<div class="buttons" mu-id="pButtons">
				<span class="btn-icon-size-4 icon-before-plus btn-icon" mu-id="bAdd">Přidat položku</span>
				<span class="btn-icon-size-4 icon-before-question-blue btn-icon" mu-id="bCreate">Spustit schvalování</span>
				<span class="btn-icon-size-4 icon-before-checked-on btn-icon" mu-id="bCreateNoApproving">Bez schvalování</span>
				<span style="display: none" class="btn-icon-size-4 icon-before-checked-off btn-icon" mu-id="bCreateTest">Test</span>
			</div>
			
			<hr />
			<!-- <h3>Související</h3>
			<div mu-widget="UiTicketRels" mu-id="ticketRels"></div> -->
			
			
		`); // <input type="text" mu-id="importPath" /><span mu-id="bImport">importovat soubor</span>
		const relsEl = this.container.querySelector('[mu-id="ticketRels"]');
		if (relsEl) {
			relsEl.setAttribute('mu-params', JSON.stringify({
				buSubjectId: this.buSubjectId,
				ticketId: this.ticketId,
				projectId: this.projectId,
			}));
		}
	}

	async bImport_click() {
		try
		{
			const eInv = await this.cl.withMessage("Hledám elektronickou verzi faktury").importDigitalInvoice(-1, this.ui.importPath.value);
			if (eInv) {
				this.muBindData(eInv);
				flashInfo('Naimportoval jsem eletronickou verzi faktury.');
			}
		} catch (ex) {
			flashInfo('Nepovedlo se naimportoval eletronickou verzi faktury.');
		}
	}

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		vendorSelector: UiTomSelect,
		ticketRels: UiTicketRels,
		attaches: UiAttaches,
	}>

	async afterIndex() {
		this.updateForm();
		if (this.invoiceId) return;

		this.muNamedWidget.attaches.ticketId = this.ticketId;
		this.muNamedWidget.attaches.loadAttaches();

		const currDate = formatDate("Y-m-d", new Date());
		this.muBindData({
			issueDate: currDate,
			maturityDate: currDate,
			vatDate: currDate,
			currencies: [
				// { value: "", text: "Vyberte měnu" },
				...(await this.cl.getAllCurrency()).map(currency => <any>{
					value: currency.id,
					text: currency.code + " (" + currency.currency + " - " + currency.country + ")",
				})
			],
		});
		const vs = this.muNamedWidget.vendorSelector;
		vs.optionLoader = async (query, callback) => {
			// @ts-ignore
			const findRes = await this.cl.findVendor(query);
			const res: TomOption[] = findRes.items;
			if (findRes.isIco) this.lastIco = findRes.query;
			callback(res, []);
		}
		vs.init();

		try
		{
			const eInv = await this.cl.withMessage("Hledám elektronickou verzi faktury").importDigitalInvoice(this.ticketId, null);
			if (eInv) {
				this.muBindData(eInv);
				flashInfo('Naimportoval jsem eletronickou verzi faktury.');
			} else {
				flashInfo('Neexistuje eletronická verze faktury.');
				this.bAdd_click();
			}
		} catch (ex) {
			flashInfo('Nepovedlo se naimportoval eletronickou verzi faktury.');
		}

		new Sortable(
			this.ui.items,
			{
				handle: '.handle'
			}
		)
	}

	vendorSelector_changeValue() {
		this.muBindData({ vendor: this.muNamedWidget.vendorSelector.valueOption });
	}

	bAdd_click() {
		this.muWidgetFromTemplate('item', 'items');
	}

	checkAll_change() {
		this.muGetChildWidgets<InvoiceCreatorItem>("items")
			.forEach(w => w.ui.forSet.checked = this.ui.checkAll.checked);
	}

	public setForAllItems(data: any) {
		this.muGetChildWidgets<InvoiceCreatorItem>("items")
			.forEach(w => {
				if (w.isChecked) {
					w.disableSetAll = true;
					w.muBindData(data);
					if ("projectId" in data) w.projectId_change();
					if ("withoutProject" in data) w.withoutProject_change();
					if ("organizationUnitId" in data) w.organizationUnitId_change();
					w.disableSetAll = false;
				}
			});
	}

	async doCreate(approvingMode: "approved"|"approving") {
		const data = this.muFetchData();
		if (this.validate(data)) {
			const res = await this.cl.createInvoice(data, this.ticketId, approvingMode);
			for(const message of res.messages) {
				flashInfo(message[0]);
			}
			this.invoiceId = res.invoiceId;
			this.updateForm();
			if (res.invoiceId) this.callMethodInFirstAncestors('onInvoiceCreated', this.ticketId);
			return res;
		}
		else
			flashError('Opravte chyby ve formuláři');
	}

	bCreate_click() {
		this.doCreate("approving");
	}

	bCreateNoApproving_click() {
		this.doCreate("approved");
	}

	async bCreateTest_click() {
		console.log(await this.doCreate("test"));
	}

	/* muFetchData(): any {
		const data = super.muFetchData();
		data.items = this.muGetChildWidgets('items').map(w => w.muFetchData());

		return data;
	}

	muBindData(srcData: any) {
		super.muBindData(srcData);
		this.muClear('items');
		for(const item of srcData.items) {
			this.muWidgetFromTemplate('item', 'items').muBindData(item);
		}
	} */
	private validate(data: any): boolean {
		let isValid = true;
		let errs: ErrorListMessages = [];
		let vsrc = {
			data: data,
			prefix: '',
		};

		const addError = (field: string, message: string) => {
			errs.push({field: vsrc.prefix + field, message});
		};
		const checkFill = (field: string, message: string) => {
			if (!vsrc.data[vsrc.prefix + field]) addError(field, message);
		};
		checkFill('vendorId', "Vyberte dodavatele");
		checkFill('issueDate', 'Zadejte datum vystavení');
		checkFill('maturityDate', 'Zadejte splatnost');
		checkFill('vatDate', 'Zadejte DUZP');
		checkFill('variableSymbol', 'Zadejte variabilní symbol');
		checkFill('invoiceNumber', 'Zadejte interní číslo faktury');
		checkFill('currencyId', 'Vyberte měnu');
		if (!vsrc.data.items?.length) addError('items', 'Musí být zadána aspoň jedna položka');

		// @ts-ignore
		let em = new ErrorMarker(this);
		em.clearErrors();
		em.markErrors(errs);
		isValid = isValid && errs.length == 0;
		errs = [];

		const witems = this.muGetChildWidgets('items');
		for(let i = 0; i < data.items.length; i++) {
			const item = data.items[i];
			// vsrc.prefix = 'items/' + i.toString() + '/';
			vsrc.data = item;

			if (!item.withoutProject && !item.projectId)
				addError('projectId', 'Vyberte projekt nebo zaklikněte "bez projektu"');
			checkFill('organizationUnitId', 'Zadejte Středisko');
			checkFill('name', 'Zadejte Název');
			checkFill('quantity', 'Zadejte Počet');
			checkFill('unitPrice', 'Zadejte Cena za jednotku bez DPH');

			em = new ErrorMarker(witems[i]);
			em.markErrors(errs);
			isValid = isValid && errs.length == 0;
			errs = [];
		}

		return isValid;
	}

	public updateForm() {
		this.muVisible(!!this.invoiceId, ["pIsCreated", "!pInvoice", "!pButtons"]);
	}

	dAddVendor_click() {
		UiDms.instance = new UiDms(null);
		UiDms.instance.cl = new DmsCL();
		const editor = this.openInModal(
			'UiBuSubjectEditor',
			'Přidat nového dodavatele',
			{}, false) as UiBuSubjectEditor;
		editor.ui.ic.focus();
		if (this.lastIco) {
			editor.ui.ic.value = this.lastIco;
			editor.bLoadFromAres_click();
		}
		editor.savedPromise.then(buSubject => {
			this.muBindData({ vendorId: "bs:" + buSubject.id });
			editor.muRemoveSelf();
		})
	}

	/* bindAttachList() {
		this.cl.getAttachesFotTicketAndRelated(this.ticketId).then(
			data => {
				this.muBindData({attachList: data/*.filter(a => a.fileName)* / });
				this.muVisible(!!data, 'pAttaches');
			}
		);
	}

	showAttach(id: number) {
		this.cl.getAttachDetail(id, this.ticketId).then(
			data => {
				this.ui.preview.innerHTML = data;
				this.muVisible(true, 'bClosePreview');
			}
		);
	}

	bClosePreview_click() {
		this.ui.preview.innerHTML = '';
		this.muVisible(false, 'bClosePreview');
	}

	showAttachJunk_change(ev: Event) {
		ev.cancelBubble = true;
		ev.stopPropagation();
		this.ui.pAttaches.classList.toggle(
			'invoice-approval--attaches__show-is-junk',
			this.ui.showAttachJunk.checked
		)
	} */
}

export class InvoiceCreatorItem extends BaseMuWidget {
	// @ts-ignore
	muParent: InvoiceCreator;
	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		projectId: UiTomSelect,
		// organizationUnitId: TreeSelector,
		organizationUnitId: UiTomSelect,
	}>;
	// @ts-ignore
	private allProjects: Promise<any[]>;
	disableSetAll: boolean = false;
	bRemove_click() {
		if (confirm('Odebrat tuto položku?')) this.muRemoveSelf();
	}

	afterIndex() {
		this.muNamedWidget.projectId.init({labelField: "title", searchField: ["title"]});
		this.muNamedWidget.projectId.missingOptionLoader = async (ids, resolve) => {
			const idsInt = ids.map(id => parseInt(id));
			const allp = (await this.allProjects);
			resolve(allp.filter(item => idsInt.includes(item.id)), []);
		};
		(async () => {
			this.allProjects = this.muParent.orgProjectPromise.fetch();
			// this.muNamedWidget.organizationUnitId.bindTree(await this.muParent.orgDivisionPromise.fetch());
			this.muNamedWidget.organizationUnitId.init({labelField: "title", searchField: ["title"]});
			this.muNamedWidget.organizationUnitId.bindItems(await this.muParent.orgDivisionPromise.fetch());
			this.bindOrgProjects();
		})();

	}

	organizationUnitId_change() {
		this.bindOrgProjects();
		// this.setForAllItems({organizationUnitId: this.muNamedWidget.organizationUnitId.getValue()});
		this.setForAllItems({organizationUnitId: this.muNamedWidget.organizationUnitId.value});
	}

	private async bindOrgProjects() {
		// const orgDivisionId = this.muNamedWidget.organizationUnitId.getValue();
		const orgDivisionId = this.muNamedWidget.organizationUnitId.value;
		this.muNamedWidget.projectId.tom.clearOptions();
		this.muNamedWidget.projectId.bindItems(orgDivisionId
			? (await this.allProjects).filter(op => op.orgDivisionId == orgDivisionId)
			: await this.allProjects
		);
	}

	projectId_change() {
		const orgProjectOpt = this.muNamedWidget.projectId.valueOption;
		if (orgProjectOpt && !this.muNamedWidget.organizationUnitId.value) {
			// this.muNamedWidget.organizationUnitId.setSelected(orgProjectOpt.orgDivisionId, false);
			this.muNamedWidget.organizationUnitId.value = orgProjectOpt.orgDivisionId;
			this.setForAllItems({projectId: orgProjectOpt.id});
		}
	}

	withoutProject_change() {
		this.muVisible(!this.ui.withoutProject.checked, 'projectId');
		this.setForAllItems({withoutProject: this.ui.withoutProject.checked});
	}

	get isChecked() {
		return this.ui.forSet.checked;
	}

	private setForAllItems(data: any) {
		if  (!this.disableSetAll) {
			this.muParent.setForAllItems(data);
		}
	}
}
